<template>
  <base-site-loader type="preview" />
</template>

<script>
import { captureException } from '@sentry/browser';
import { sendQuizFormRequest } from '@/services/sendQuizFormRequest';
import store from '@/store';
import { applyQuizFormDefaults } from '@/services/applyQuizFormDefaults';

const DEFAULT_ERROR_KEY = 'errors.default';

export default {
  props: {
    data: Object,
  },
  methods: {
    async createSitePreview(form) {
      try {
        const formWithDefaults = applyQuizFormDefaults(this.$t('quizFormDefaults'), form);

        const language = this.$i18n.locale;
        const response = await sendQuizFormRequest({
          ...formWithDefaults,
          language,
        });
        this.handleSiteCreation(response);
      } catch (error) {
        this.handleRequestError(error);
      }
    },
    handleSiteCreation(data) {
      const {
        autoLoginUrl,
        siteUrl,
        jwt,
        publishedSiteDomain,
        constructorDomain,
        payment: { currency, email, formUrl, amount },
      } = data;

      const storeData = {
        autoLoginUrl,
        currency,
        formUrl,
        siteUrl,
        amount,
        email,
        jwt,
        publishedSiteDomain,
        constructorDomain,
      };

      store.assign(storeData).saveToLS();

      this.goToSitePreview();
    },
    handleRequestError(error) {
      if (!error) {
        return;
      }

      if (error.name === 'IncorrectPassword') {
        this.showError(error.name);
        this.goToAuth();
        return;
      }

      if (error.name === 'EmailAlreadyOccupied') {
        this.goToAuth();
        return;
      }

      this.showError(error.name);
      captureException(error);
      // eslint-ingore-next-lines no-console
      console.error(error);
      this.goToWizard();
    },
    showError(key) {
      if (this.$i18n) {
        const errorKey = this.$te(`errors.${key}`) ? `errors.${key}` : DEFAULT_ERROR_KEY;
        this.$showError(this.$t(errorKey));
      }
    },
    goToWizard() {
      this.$router.push({
        name: 'wizard',
      });
    },
    goToAuth() {
      this.$router.push({
        name: 'auth',
        params: { data: this.data },
      });
    },
    goToSitePreview() {
      this.$router.push('/preview');
    },
  },
  mounted() {
    if (!this.data) {
      this.goToWizard();
      return;
    }

    this.createSitePreview(this.data);
  },
};
</script>
